import { AxiosResponse } from 'axios';
import AxiosClient, { headerAuthorizeAxiosClient } from '../utils/AxiosClient';

export interface Response<T> {
  data: T;
  msg: string;
  // eslint-disable-next-line camelcase
  sub_code: number;
}

export function resolve<T>(promise: Promise<AxiosResponse<Response<T>>>) {
  return promise.then((response) => {
    return response.data.data;
  });
}

export const client = new AxiosClient({
  baseURL: process.env.REACT_APP_API_ENDPOINT,
});

export const storeHomeClient = new AxiosClient({
  baseURL: process.env.REACT_APP_STORE_HOME_API_ENDPOINT,
});

export const marketingHomeClient = new AxiosClient({
  baseURL: process.env.REACT_APP_MARKETING_HOME_API_ENDPOINT,
});

export const itemClient = new AxiosClient({
  baseURL: process.env.REACT_APP_ITEM_API_ENDPOINT,
});

export const storeHomeHyphenV1Client = new AxiosClient({
  baseURL: process.env.REACT_APP_STORE_HOME_HYPHEN,
});

export const forbiddenWordClient = new AxiosClient({
  baseURL: process.env.REACT_APP_FORBIDDEN_WORD_API_ENDPOINT,
});

export const superBookAuthClient = new AxiosClient({
  baseURL: process.env.REACT_APP_SUPER_BOOK_AUTH_ENDPOINT,
});

export const superBookDashBoardClient = new AxiosClient({
  baseURL: process.env.REACT_APP_SUPER_BOOK_DASHBOARD_ENDPOINT,
});

export function authorize(token: string) {
  headerAuthorizeAxiosClient(client, token, {
    headerName: process.env.REACT_APP_AUTH_HEADER,
    prefix: 'Bearer ',
  });
  headerAuthorizeAxiosClient(storeHomeClient, token, {
    headerName: process.env.REACT_APP_AUTH_HEADER,
    prefix: 'Bearer ',
  });

  headerAuthorizeAxiosClient(itemClient, token, {
    headerName: process.env.REACT_APP_AUTH_HEADER,
    prefix: 'Bearer ',
  });

  headerAuthorizeAxiosClient(forbiddenWordClient, token, {
    headerName: process.env.REACT_APP_AUTH_HEADER,
    prefix: 'Bearer ',
  });

  headerAuthorizeAxiosClient(superBookAuthClient, token, {
    headerName: process.env.REACT_APP_AUTH_HEADER,
    prefix: 'Bearer ',
  });

  headerAuthorizeAxiosClient(marketingHomeClient, token, {
    headerName: process.env.REACT_APP_AUTH_HEADER,
    prefix: 'Bearer ',
  });

  headerAuthorizeAxiosClient(storeHomeHyphenV1Client, token, {
    headerName: process.env.REACT_APP_AUTH_HEADER,
    prefix: 'Bearer ',
  });
}

export function authorizeSuperbookToken(token: string) {
  headerAuthorizeAxiosClient(superBookDashBoardClient, token, {
    headerName: process.env.REACT_APP_AUTH_HEADER,
    prefix: 'Bearer ',
  });
}
